import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AppContextProvider } from '../../../Services/AppContext';
import { store } from '../../../store/store';
import { loadDOMComponent } from '../../../helpers';
import CaseChatMediaViewerButton from './CaseChatMediaViewerButton';

loadDOMComponent({
	selector: 'react-case-chat-media-viewer-button',
	// @ts-ignore
	callback: ({ container, context, props }) => {
		const documentationFileId = container.getAttribute(
			'data-documentationFileId',
		);

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CaseChatMediaViewerButton
						documentationFileId={documentationFileId}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
